// Credit: https://stackoverflow.com/a/63391413
import { Pipe, PipeTransform } from "@angular/core";
import { orderBy } from "lodash-es";

@Pipe({
    name: "orderBy",
})
export class OrderByPipe implements PipeTransform {
    transform<T>(array: T[], sortBy: string, order?: boolean | "asc" | "desc"): T[] {
        const sortOrder = order ? order : "asc"; // setting default ascending order

        return orderBy(array, [sortBy], [sortOrder]);
    }
}
